/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { StyledChatFooterNew } from './ChatFooterNew.styled';
import ChatInput from './components/ChatInput/ChatInput';
import { ChatReference } from 'api/rest/chat_new';
import { forwardRef } from 'react';

interface Props {
    setMessages: any;
    room: string;
    chatUserIds: number[];
    hasAccess?: boolean;
    initialMessage?: string;
    references?: ChatReference[];
}

const ChatFooterNew = forwardRef((props: Props, ref) => {
    const { setMessages, room, chatUserIds, hasAccess, initialMessage, references } = props;

    return (
        <>
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/*// @ts-ignore*/}
            <StyledChatFooterNew ref={ref}>
                <ChatInput
                    setMessages={setMessages}
                    room={room}
                    chatUserIds={chatUserIds}
                    hasAccess={hasAccess}
                    initialMessage={initialMessage}
                    references={references}
                />
            </StyledChatFooterNew>
        </>
    );
});

export default ChatFooterNew;
